import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from "@coreui/react-pro";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { confirmBox } from "src/actions/confirmBox";

const ConfirmModal = () => {
	const dispatch = useDispatch();
	const confirmText = useSelector(state => state.confirmBox?.confirmText);
	const onConfirm = useSelector(state => state.confirmBox?.onConfirm);
	const visible = useSelector(state => state.confirmBox?.visible);
	// Optional, so a caller can name the object / action (guide §12: a confirm
	// dialog's title names the thing, never "Are you sure?").
	const title = useSelector(state => state.confirmBox?.title);
	const confirmLabel = useSelector(state => state.confirmBox?.confirmLabel);

	return (
		<>
			<CModal
				className="app-font"
				visible={visible}
				onClose={() => confirmBox.close(dispatch)}
				aria-labelledby='confirmModal'
				backdrop='static'
			>
				<CModalHeader onClose={() => confirmBox.close(dispatch)}>
					<CModalTitle id='confirmModal'>{title || 'Confirm'}</CModalTitle>
				</CModalHeader>
				<CModalBody>
					<p style={{ whiteSpace: 'pre-line' }}>{confirmText}</p>
				</CModalBody>
				<CModalFooter>
					<CButton className='outline-btn' onClick={() => confirmBox.close(dispatch)}>
						Cancel
					</CButton>
					<CButton className='primary-btn' onClick={onConfirm}>
						{confirmLabel || 'Confirm'}
					</CButton>
				</CModalFooter>
			</CModal>
		</>
	);
};

export default ConfirmModal;